/**
 * Fleet ▸ Vessels ▸ Setup Changes ekranının metinleri (ADR 0142 §3): kurulumdaki etkin gemide
 * ofisin PMS değişiklikleri ve gemideki sonuçları. Ekran ve alan adları İngilizce (menü dili);
 * Türkçe ikinci dil.
 */

export const pmsSetupChangesEn = {
  title: 'Setup Changes',
  description:
    'Changes the office made to the planned maintenance system of a vessel in setup, and whether the vessel applied them.',
  vessel: 'Vessel',
  module: 'Module',
  allModules: 'All modules',
  listTitle: 'Changes',
  open: 'View changes',
  modules: {
    equipment: 'Equipment',
    job_definitions: 'Maintenance Plan',
  },
  ops: {
    create: 'Added',
    update: 'Edited',
    remove: 'Removed',
  },
  statuses: {
    pending: 'Pending',
    applied: 'Applied',
    rejected: 'Rejected',
  },
  kpi: {
    all: 'All changes',
    pending: 'Waiting for the vessel',
    applied: 'Applied on board',
    rejected: 'Not applied',
  },
  columns: {
    status: 'Status',
    module: 'Module',
    change: 'Change',
    record: 'Record',
    requestedBy: 'Requested By',
    requestedAt: 'Requested',
    result: 'Result',
  },
  removeReason: 'Reason: {{reason}}',
  appliedAt: 'Applied {{at}}',
  rejectedAt: 'Rejected {{at}}',
  waiting: 'Applied at the next sync',
  /** Gemide ret kodunun bu ekrandaki anlamı; yoksa PMS hata metni. */
  reasons: {
    ROW_VERSION_CONFLICT:
      'The record was changed on board in the meantime; the vessel kept its version.',
  } as Record<string, string>,
  stage: {
    setup: 'Setup',
    live: 'Live',
  },
  notActivated:
    'The vessel server is not activated yet: the office edits this vessel directly, so no changes are sent.',
  live: 'This vessel is live. Office changes to equipment and jobs are still sent to the vessel and applied at its next sync; a record changed on board in the meantime is not overwritten.',
  empty: 'No setup changes yet',
  emptyHint:
    'When the office adds, edits or removes equipment or jobs for this vessel during setup, the changes appear here.',
  noMatch: 'No change matches the filters.',
  noVessel: 'No vessel',
  noVesselHint: 'Add a vessel in Fleet ▸ Vessels first.',
};

export const pmsSetupChangesTr: typeof pmsSetupChangesEn = {
  title: 'Kurulum Değişiklikleri',
  description:
    'Kurulumdaki geminin planlı bakım sisteminde ofisin yaptığı değişiklikler ve geminin bunları uygulayıp uygulamadığı.',
  vessel: 'Gemi',
  module: 'Modül',
  allModules: 'Bütün modüller',
  listTitle: 'Değişiklikler',
  open: 'Değişiklikleri gör',
  modules: {
    equipment: 'Ekipman',
    job_definitions: 'Bakım Planı',
  },
  ops: {
    create: 'Eklendi',
    update: 'Düzeltildi',
    remove: 'Kaldırıldı',
  },
  statuses: {
    pending: 'Bekliyor',
    applied: 'Uygulandı',
    rejected: 'Reddedildi',
  },
  kpi: {
    all: 'Bütün değişiklikler',
    pending: 'Gemiyi bekleyen',
    applied: 'Gemide uygulanan',
    rejected: 'Uygulanamayan',
  },
  columns: {
    status: 'Durum',
    module: 'Modül',
    change: 'Değişiklik',
    record: 'Kayıt',
    requestedBy: 'Yapan',
    requestedAt: 'Tarih',
    result: 'Sonuç',
  },
  removeReason: 'Gerekçe: {{reason}}',
  appliedAt: '{{at}} uygulandı',
  rejectedAt: '{{at}} reddedildi',
  waiting: 'Sonraki senkronda uygulanır',
  reasons: {
    ROW_VERSION_CONFLICT: 'Kayıt arada gemide değiştirilmiş; gemi kendi sürümünü korudu.',
  },
  stage: {
    setup: 'Kurulum',
    live: 'Canlı',
  },
  notActivated:
    'Gemi sunucusu henüz etkin değil: ofis bu gemiyi doğrudan düzenler, değişiklik gönderilmez.',
  live: 'Bu gemi kullanımda. Ofisin ekipman ve iş değişiklikleri yine gemiye gönderilir ve geminin sonraki senkronunda uygulanır; arada gemide değişen kayıt ezilmez.',
  empty: 'Henüz kurulum değişikliği yok',
  emptyHint:
    'Ofis kurulumda bu gemiye ekipman ya da iş ekleyince, düzeltince ya da kaldırınca değişiklikler burada görünür.',
  noMatch: 'Süzgeçlere uyan değişiklik yok.',
  noVessel: 'Gemi yok',
  noVesselHint: 'Önce Fleet ▸ Vessels ekranında gemi ekleyin.',
};
